import { render } from "./UserInvitationPage.vue?vue&type=template&id=6b40223b"
import script from "./UserInvitationPage.vue?vue&type=script&lang=js"
export * from "./UserInvitationPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__